<template>
  <div class="projects-container">
    <section class="projects-section-body">
      <div class="section-title">
        <h2>Featured Projects</h2>
        <p>Below are a few of the recent projects I've been working on.</p>
      </div>

      <section class="cards-section">
        <article class="card" id="first-card">
          <a
            href="https://github.com/Jdevv96/countOnMe"
            target="_blank"
            class="card-image"
            ><img src="../../images/arithmetic-2.jpg" alt="" />
          </a>
          <div class="card-text">
            <h3 class="card-title">Count On Me</h3>
            <p class="card-description">
              A simple to use arithmetic calculator app. The app can perform
              basic functions like addition, subtraction, multiplication and
              division. Built using HTML, CSS and JavaScript.
            </p>
            <p class="mobile-description">
              A simple to use arithmetic calculator app. Built using HTML CSS
              and JavaScript.
            </p>
          </div>
          <div class="card-tech-stack">
            <img
              alt="HTML"
              width="30px"
              style="padding-right: 10px"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original-wordmark.svg"
            />
            <img
              alt="CSS"
              width="30px"
              style="padding-right: 10px"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original-wordmark.svg"
            />
            <img
              alt="JavaScript"
              width="30px"
              style="padding-right: 10px"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
            />
          </div>

          <div class="view-project">
            <a
              href="https://github.com/Jdevv96/countOnMe"
              class="repo-link"
              target="_blank"
              ><button class="source-code">
                Source Code
                <font-awesome-icon
                  icon="fa-solid fa-circle-arrow-right"
                /></button
            ></a>
            <a
              href="https://jdevv96.github.io/countOnMe/"
              class="live-link"
              target="_blank"
              ><button class="demo">
                Live Demo
                <font-awesome-icon icon="fa-solid fa-circle-play" /></button
            ></a>
          </div>
        </article>
        <article class="card" id="second-card">
          <a
            href="https://github.com/Jdevv96/dailyDoesIt-Tracker"
            class="card-image"
            target="_blank"
          >
            <img src="../../images/productivity.png" alt="" />
          </a>
          <h3 class="card-title">Daily Does It | Tracker</h3>
          <p class="card-description">
            A helpful to-do list app that allows you to add, complete and track
            your overall progress. The focus of this app was to explore a new
            framework while implementing a solution aimed toward productivity
            enthusiasts. Built with Vue.js.
          </p>
          <p class="mobile-description">
            A helpful to-do list front-end app that allows you to track and
            complete daily tasks. Built using Vue.js.
          </p>
          <div class="card-tech-stack">
            <img
              alt="vuejs"
              width="30px"
              style="padding-right: 10px"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original-wordmark.svg"
            />
          </div>
          <div class="view-project">
            <a
              href="https://github.com/Jdevv96/dailyDoesIt-Tracker"
              class="repo-link"
              target="_blank"
              ><button class="source-code">
                Source Code
                <font-awesome-icon
                  icon="fa-solid fa-circle-arrow-right"
                /></button
            ></a>
            <a
              href="https://jdevv96.github.io/dailyDoesIt-Tracker/"
              class="live-link"
              target="_blank"
              ><button class="demo">
                Live Demo
                <font-awesome-icon icon="fa-solid fa-circle-play" /></button
            ></a>
          </div>
        </article>
        <!-- <article class="third-card">
          <a href="#" class="card-image"
            ><img src="../../images/pic05.jpg" alt=""
          /></a>
          <h3 class="card-title">Ante fermentum</h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing vehicula id nulla
            dignissim dapibus ultrices.
          </p>
          <div class="view-project">
            <button class="source-code">
              Source Code
              <font-awesome-icon icon="fa-solid fa-circle-arrow-right" />
            </button>
            <button class="demo">
              Live Demo <font-awesome-icon icon="fa-solid fa-circle-play" />
            </button>
          </div>
        </article>
        <article class="fourth-card">
          <a href="#" class="card-image"
            ><img src="../../images/pic04.jpg" alt=""
          /></a>
          <h3 class="card-title">Fusce consequat</h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing vehicula id nulla
            dignissim dapibus ultrices.
          </p>
          <div class="view-project">
            <button class="source-code">
              Source Code
              <font-awesome-icon icon="fa-solid fa-circle-arrow-right" />
            </button>
            <button class="demo">
              Live Demo <font-awesome-icon icon="fa-solid fa-circle-play" />
            </button>
          </div>
        </article> -->
      </section>
      <div class="view-repo">
        <a href="https://github.com/Jdevv96?tab=repositories" target="_blank">
          <button class="repo">View My Repo</button>
        </a>
      </div>
      <p class="footer-p">
        Check out my Github for a full look at what I'm working on and what new
        technologies I'm exploring.
        <br />
        Be sure to check back often as I'm constantly taking on new challenges.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "ProjectsSection",
};
</script>

<style>
.projects-container {
  color: white;
  height: 100vh;
}

.section-title h2 {
  font-size: 3rem;
}

.cards-section {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 650px;
  margin-top: 4rem;
}

.card {
  padding: 1.75em 1.75em 0.1em 1.75em;
  border-radius: 20px;
  background: #644061;
  max-width: 400px;
  height: auto;
}

.card-title {
  font-size: 20px;
  letter-spacing: 1px;
}

#first-card {
  margin-right: 4em;
}

.cards-section article .card-image img {
  border-radius: 20px;
  width: 100%;
  height: 300px;
}

.card-image {
  display: block;
  margin-bottom: 1.75em;
  margin-left: -1.75em;
  margin-top: -1.75em;
  position: relative;
  width: calc(100% + 3.5em);
}

.card-description {
  height: 150px;
  font-size: 20px;
  letter-spacing: 0.5px;
}

.mobile-description {
  display: none;
}

.card-tech-stack {
  padding-top: 15px;
}

.view-project {
  margin: 20px 0;
}

.view-project button,
.view-repo button {
  text-transform: capitalize;
  padding: 10px 20px;
  background: #e95420;
  color: white;
  font-size: 20px;
  border: 0;
  cursor: pointer;
  border-radius: 30px;
}

.source-code {
  margin-right: 10px;
}

.view-repo {
  text-decoration: none;
  margin-top: 5rem;
}

.footer-p,
.section-title p {
  margin-top: 3rem;
  font-size: 20px;
}

@media only screen and (max-width: 1000px) {
  .projects-container {
    overflow: hidden;
  }
  .cards-section {
    margin-top: 3em;
    justify-content: space-evenly;
  }

  .card {
    max-width: 200px;
    height: 75%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  .card-title {
    font-size: 1.5rem;
  }

  .card-image {
    display: none;
  }

  .card-description {
    display: none;
  }

  .mobile-description {
    font-size: 20px;
    display: block;
  }

  .view-project button,
  .view-repo button {
    font-size: 18px;
    padding: 8px 14px;
  }

  .repo-link {
    margin: 1em 0;
  }

  .view-project {
    display: flex;
    flex-direction: column;
  }

  .view-repo {
    margin: 0 0 2em 0;
  }

  .footer-p {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .projects-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .section-title h2 {
    font-size: 2rem;
  }

  .section-title p {
    display: none;
  }

  .cards-section {
    flex-direction: column;
    margin-top: 0;
    height: 100%;
  }

  .card {
    max-width: 200px;
  }

  #first-card {
    margin: 0 0 2em 0;
  }

  .card-title {
    font-size: 1rem;
  }

  .card-image {
    display: none;
  }

  .card-description {
    display: none;
  }

  .card-tech-stack {
    display: none;
  }

  .view-project button,
  .view-repo button {
    font-size: 16px;
    padding: 6px 12px;
  }

  .repo-link {
    margin: 1em 0;
  }

  .view-project {
    display: flex;
    flex-direction: column;
  }

  .view-repo {
    margin: 2em 0;
  }

  .footer-p {
    display: none;
  }
}
</style>
